import { render } from "./User.vue?vue&type=template&id=7109f638&scoped=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"

import "./User.vue?vue&type=style&index=0&id=7109f638&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7109f638"

export default script